const selector = document.querySelector('.eu-cookie-banner-closed');
const firstCookieBannerButton = '.eu-cookie-compliance-more-button';

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function inertWithCookieBanner() {

    waitForElm(firstCookieBannerButton).then((elm) => {
        elm.onfocus = (event) => {
            selector.setAttribute('inert','true');
        };

        document.querySelector('.eu-cookie-compliance-save-preferences-button').addEventListener('click', (e) => {
            selector.removeAttribute('inert');
        });
        document.querySelector('.agree-button.eu-cookie-compliance-default-button').addEventListener('click', (e) => {
            selector.removeAttribute('inert');
        });
        document.querySelector('.decline-button.eu-cookie-compliance-default-button').addEventListener('click', (e) => {
            selector.removeAttribute('inert');
        });
    });
}
